import React,{useRef,useEffect,useState} from 'react';
import {diff} from 'deep-object-diff'
import {connect} from "react-redux";
import {cleanDiffs,runAs,obtainRoleData,obtainRoleOrder,updateObjects,allRoles,sendUpdate} from "src/containers/TDP/TDPBroadcastFunctions";
import {isCurrentHost} from "src/containers/gameTime/common/gameTimeFunctions";
import store from 'src/store';


let previousItem = {emcee:{},host:{},guest:{},guardian:{},child:{}};
let currentItem = {emcee:{},host:{},guest:{},guardian:{},child:{}};

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const makeNewData = (roles) => {
    //eslint-disable-next-line
    allRoles.map((roleName)=> {
        let data = obtainRoleData(roleName).data;
        let order = obtainRoleOrder(roleName);
        //eslint-disable-next-line
        order.map((item)=>{
            currentItem[roleName][item] = Object.assign({},data[item]);
            //eslint-disable-next-line
            previousItem[roleName][item] = usePrevious(JSON.parse(JSON.stringify(currentItem[roleName][item])));
        });
    });
};

const TDPBroadcaster = (props) =>{
    let stateData = store.getState();
    //Force is for certain messages that need to be sent in their entirty such a websocket requests
    let [force,setForce] = useState(false);
    let roles = runAs();
    let websocketrequests = JSON.stringify(props.webSocketUpdateRequests);
    useEffect(()=>{
        if(isCurrentHost()) {
            setForce(true);
        }

    },[websocketrequests]);

    makeNewData(roles);

    //eslint-disable-next-line
    roles.map((roleName)=> {
        let order = obtainRoleOrder(roleName);

        //eslint-disable-next-line
        order.map((item) => {
            if ((force || updateObjects[item].type === "complete") && currentItem.host[item] && Object.keys(currentItem.host[item]).length > 0) {
                sendUpdate(updateObjects[item].scope,
                    updateObjects[item].method,
                    Object.assign({}, currentItem.host[item],{force:true}));
                setForce(false);
            } else {
                //check If the data they should share has changed
                //eslint-disable-next-line
                    Object.keys(currentItem[roleName][item]).map((layer2)=>{
                        if(!Array.isArray(currentItem[roleName][item][layer2]) &&
                            !(typeof currentItem[roleName][item][layer2] === 'object') &&
                            ((currentItem[roleName][item][layer2]===previousItem[roleName][item][layer2]) || (currentItem[roleName][item][layer2]===undefined))
                        ){
                            delete currentItem[roleName][item][layer2]
                        }
                        /*currentItem[roleName][item][layer2] = (
                                ? currentItem[roleName][item][layer2]
                                : typeof currentItem[roleName][item][layer2] === 'object'
                                    ? currentItem[roleName][item][layer2]
                                    : currentItem[roleName][item][layer2]
                        );*/
                    });
//diff(previousItem[roleName][item][layer2], currentItem[roleName][item][layer2])

                    let cleanedDiffs = cleanDiffs(currentItem[roleName][item]);
                if (Object.keys(cleanedDiffs).length > 0) {
                    if (updateObjects.hasOwnProperty(item)) {
                        //Send it
                        sendUpdate(updateObjects[item].scope,
                            updateObjects[item].method,
                            cleanedDiffs);
                    }
                }
            }
        });
    });
        return <span id="TDPBroadcaster" style={{display: "none"}}>&nbsp;</span>

};

const mapStateToProps = (state) =>{
    return {
        appSettings:state.appSettings,
        gameTime:state.gameTime,
        currentActivityData:state.currentActivityData,
        webSocketUpdateRequests:state.webSocketUpdateRequests,
        activityRemoteResponses:state.activityRemoteResponses,
        submitTeamForApproval:state.submitTeamForApproval,
        activityResponse:state.activityResponse,
    };
};

export default connect(mapStateToProps,{

})(TDPBroadcaster);
